import React from "react";
import {DashboardBrokerUsage} from "../../types/DashboardBrokerUsage";
import {BrokerUsageRow} from "./BrokerUsageRow";
import {useExpandCollapseBox} from "../common/hooks/useExpandCollapseBox";

interface BrokerUsageBoxProps {
    brokerUsages: DashboardBrokerUsage[];
    expanded: boolean;
    onToggleExpanded: (expanded: boolean) => void;
}

const COLLAPSED_BROKER_USAGE_COUNT = 4;

let renderBrokerUsageRows = function (brokerUsages: DashboardBrokerUsage[]) {
    return brokerUsages.map((brokerUsage) => (
        <BrokerUsageRow key={brokerUsage.broker_id} brokerUsage={brokerUsage}/>
    ));
};

export let BrokerUsageBox = function (props: BrokerUsageBoxProps) {
    let leftColumnCount = Math.ceil(props.brokerUsages.length / 2);
    let leftColumnBrokerUsages = props.brokerUsages.slice(0, leftColumnCount);
    let rightColumnBrokerUsages = props.brokerUsages.slice(leftColumnCount);
    let collapsedBrokerUsages = props.brokerUsages.slice(0, COLLAPSED_BROKER_USAGE_COUNT);
    let {boxRef, overlayRef, contentRef, renderExpanded, reservedSlotHeight} = useExpandCollapseBox({expanded: props.expanded, contentDependency: props.brokerUsages});
    return (
        <div className="broker-usage-slot" style={reservedSlotHeight ? {minHeight: reservedSlotHeight} : undefined}>
        <div ref={boxRef} className={renderExpanded ? "broker-usage-box expanded" : "broker-usage-box"}>
            {renderExpanded && (
                <div ref={overlayRef} className="broker-usage-overlay" onClick={() => props.onToggleExpanded(false)}/>
            )}
            <div ref={contentRef} className="broker-usage-content">
                <div className="broker-usage-header">
                    <div className="broker-usage-title">Broker Usage</div>
                </div>
                <div className="dashboard-box-divider"/>
                {props.brokerUsages.length === 0 ? (
                    <div className="broker-usage-empty">No broker assignments found.</div>
                ) : renderExpanded ? (
                    <div className="broker-usage-columns">
                        <div className="broker-usage-column">{renderBrokerUsageRows(leftColumnBrokerUsages)}</div>
                        <div className="broker-usage-column">{renderBrokerUsageRows(rightColumnBrokerUsages)}</div>
                    </div>
                ) : (
                    <div className="broker-usage-rows">{renderBrokerUsageRows(collapsedBrokerUsages)}</div>
                )}
                <img
                    className="broker-usage-toggle-icon"
                    src={renderExpanded ? "/static/images/collapse-arrows-textcolor.svg" : "/static/images/expand-arrows-textcolor.svg"}
                    alt={renderExpanded ? "Collapse" : "Expand"}
                    onClick={() => props.onToggleExpanded(!renderExpanded)}
                />
            </div>
        </div>
        </div>
    );
};
